import React from "react";
import { initiateGoogleAuth } from "./googleAuth";
import { SecondaryButton } from "../../../design-system";
import { GoogleIcon } from "../../../design-system/icons";
import { textColors } from "../../../design-system/tokens";

const GoogleAuthButton = ({ mode = "login", className = "", disabled = false, onClick }) => {
  const handleGoogleAuth = () => {
    if (disabled) return;
    if (typeof onClick === "function") {
      const shouldContinue = onClick();
      if (shouldContinue === false) return;
    }
    initiateGoogleAuth(mode);
  };

  const buttonText = "Continue with Google";
  const ariaLabel = "Continue with Google";

  // Special styling: always-white Google CTA in light mode, dark Google CTA in dark mode
  const googleCtaClasses = [
    "bg-white dark:bg-dark-900",
    "hover:bg-gray-50 dark:hover:bg-dark-800",
    "text-gray-900 dark:text-white",
    "border",
    "border-gray-200 dark:border-dark-700",
    "shadow-sm",
  ].join(" ");

  return (
    <SecondaryButton
      type="button"
      onClick={handleGoogleAuth}
      disabled={disabled}
      aria-label={ariaLabel}
      fullWidth
      leftIcon={<GoogleIcon size="sm" />}
      className={`${googleCtaClasses} ${className}`.trim()}
    >
      {buttonText}
    </SecondaryButton>
  );
};

export default GoogleAuthButton;
